function ScrollTop() {
  return (
    <a href='#home' className='scrollup' id='scroll-top'>
      <i className='uil uil-arrow-up scrollup__icon'></i>
    </a>
  );
}

export default ScrollTop;
